

import {

    SET_PERSONAL_DATA,
} from "../Actions/actionType";

const INITIAL_STATE = {
    personalInfo: null,
    backgroundCheck: null,
    setLesson: null,
    address: null,
    faq: null,
    price: null,
    setAvailability: null,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_PERSONAL_DATA:
            return {
                ...state,
                personalInfo:
                    action.payload.type == "personal-info"
                        ? action.payload.data
                        : state.personalInfo,
                backgroundCheck:
                    action.payload.type == "background-check"
                        ? action.payload.data
                        : state.backgroundCheck,
                setLesson:
                    action.payload.type == "set-lesson"
                        ? action.payload.data
                        : state.setLesson,
                address:
                    action.payload.type == "address"
                        ? action.payload.data
                        : state.address,
                faq:
                    action.payload.type == "faq"
                        ? action.payload.data
                        : state.faq,
                price:
                    action.payload.type == "price"
                        ? action.payload.data
                        : state.price,
                setAvailability:
                    action.payload.type == "setAvailability"
                        ? action.payload.data
                        : state.setAvailability,
            };
        default:
            return state;
    }
};
